import { FC, useState } from 'react';

import { CloseIcon } from '../../../assets/icons/index';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';

export const ConfidentialityBanner: FC = () => {
  const [isVisible, setVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="flex items-start justify-between gap-4 bg-[#172335] px-6 py-3 text-xs font-[450] text-white">
      <span>
        <AppFormattedMessage id="SHARE_PUBLIC_BANNER" />
      </span>
      <button aria-label="Dismiss" className="shrink-0" onClick={() => setVisible(false)}>
        <CloseIcon iconColor="#FFFFFF" />
      </button>
    </div>
  );
};
